import * as React from "react";
import ReportPreview, { ReportPreviewError } from "../report-preview";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { defineMessages, FormattedMessage, FormattedTime, InjectedIntlProps, injectIntl } from "react-intl";
import { downloadReport, printReport } from "src/helpers/report-utils";
import { IModifiedReportDto, ReportDto } from "src/services";
import { reportUpdateAction } from "src/actions";
import "./style.css";

interface IReportSummaryProps extends InjectedIntlProps {
  report: ReportDto;
  reportUpdateAction: (report: IModifiedReportDto) => void;
}

interface IReportSummaryState {
  newDescription: string | undefined;
  error: string | undefined;
}

export const reportSummryMessages = defineMessages({
  usernamePlaceholder: {
    defaultMessage: "Enter description",
    id: "report-summary.description.placeholder"
  }
});

class ReportSummary extends React.Component<IReportSummaryProps, IReportSummaryState> {
  constructor(props: IReportSummaryProps) {
    super(props);

    this.state = { newDescription: this.props.report.description, error: undefined };
    this.handleDescriptionCancel = this.handleDescriptionCancel.bind(this);
  }

  public handleDescriptionCancel() {
    this.setState({ newDescription: this.props.report.description });
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error: error.message });
  }

  public componentWillReceiveProps(nextProps: IReportSummaryProps, nextContext: any) {
    this.setState({ error: undefined });
  }

  public componentDidMount() {
    this.setState({ newDescription: this.props.report.description });
  }

  public componentDidUpdate(prevProps: IReportSummaryProps) {
    if (prevProps.report.description !== this.props.report.description) {
      this.setState({ newDescription: this.props.report.description });
    }
  }

  public render() {
    const formatMessage = this.props.intl.formatMessage;

    return (
      <div className="report-summary">
        <div className="button-bar">
          <Button
            className="image-button print-button"
            onClick={e => {
              e.stopPropagation();
              this.handlePrintReport(this.props.report);
            }}
          >
            <FormattedMessage id="report-preview.button.print" defaultMessage="Print" />
          </Button>
          <Button
            className="image-button download-button"
            onClick={e => {
              e.stopPropagation();
              downloadReport(this.props.report.id, this.props.report);
            }}
          >
            <FormattedMessage id="report-preview.button.download" defaultMessage="Download" />
          </Button>
        </div>
        <div className="report-summary__title">
          <FormattedMessage id="report-summary.title" defaultMessage="Summary" />
        </div>
        <table>
          <tbody>
            <tr>
              <td className="field">
                <FormattedMessage id="report-summary.label.date" defaultMessage="Date:" />
              </td>
              <td className="value">
                {this.props.report && this.props.report.creationTime && (
                  <FormattedTime value={this.props.report.creationTime} year="numeric" month="numeric" day="numeric" />
                )}
              </td>
            </tr>
            <tr>
              <td className="field">
                <FormattedMessage id="report-summary.label.type" defaultMessage="Type:" />
              </td>
              <td className="value">{this.props.report.reportType}</td>
            </tr>
            <tr>
              <td className="field">
                <FormattedMessage id="report-summary.label.description" defaultMessage="Description:" />
              </td>
              <td className="value">
                <textarea
                  value={this.state.newDescription}
                  placeholder={formatMessage(reportSummryMessages.usernamePlaceholder)}
                  onChange={e => this.setState({ newDescription: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <div className="description-button-bar">
                  <Button className="secondary-button" onClick={this.handleDescriptionCancel}>
                    <FormattedMessage id="report-summary.description.button.cancel" defaultMessage="Cancel" />
                  </Button>
                  <Button className="image-button save-button" onClick={this.handleSaveDescriptionClick}>
                    <FormattedMessage id="report-summary.description.button.save" defaultMessage="Save" />
                  </Button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="report-summary__title">
          <FormattedMessage id="report-summary.report-preview" defaultMessage="Report Preview" />
        </div>
        <div className="report-preview-container">
          {this.state.error !== undefined ? (
            ReportPreviewError
          ) : (
            <ReportPreview report={this.props.report} isSmallWindow={true} />
          )}
        </div>
      </div>
    );
  }

  private handlePrintReport = (report: ReportDto) => {
    const newWindow = window.open("", "_blank");

    printReport(report, newWindow);
  };

  private handleSaveDescriptionClick = (e: any) => {
    const modifiedReport: IModifiedReportDto = {
      description: this.state.newDescription,
      id: this.props.report.id,
      name: this.props.report.name
    };
    this.props.reportUpdateAction(modifiedReport);
    this.props.report.description = this.state.newDescription;
  };
}

export default connect(
  null,
  { reportUpdateAction }
)(injectIntl(ReportSummary));



// WEBPACK FOOTER //
// ./src/components/report-summary/index.tsx